import { Segment } from './records/Segment';

export function createSegmentForm(props = {}) {
  return props instanceof Segment ? props : new Segment(props);
}
